export default {
    SET_BROADCAST(state, data) {
        state.listMailSendBulk = data
    },
    SET_INFO_DB(state, payload){
        state.infoDB = payload
    },

}